import { useContext, useEffect, useState } from 'react';
import { SplitContext, useTreatments } from '@splitsoftware/splitio-react';

import {
    AP_FEATURE_FLAG,
    AP_LOCALSTORAGE_KEY,
    AP_MODULES_AND_PAGE_TREATMENT,
    AP_MODULES_TREATMENT,
    AP_PAGE_ORGANIC,
} from 'constants/featureFlags/assortmentPreview';

export const apLocalStorage = localStorage.getItem(AP_LOCALSTORAGE_KEY);

const inApLocalStorage =
    apLocalStorage === AP_MODULES_TREATMENT ||
    apLocalStorage === AP_MODULES_AND_PAGE_TREATMENT ||
    apLocalStorage === AP_PAGE_ORGANIC;

const inApPhaseTwoLocalStorage = apLocalStorage === AP_MODULES_AND_PAGE_TREATMENT || apLocalStorage === AP_PAGE_ORGANIC;

export default function useInAssortmentPreview() {
    const [inAssortmentPreview, setInAssortmentPreview] = useState(false);
    const [inAssortmentPreviewPhaseTwo, setInAssortmentPreviewPhaseTwo] = useState(false);

    const treatments = useTreatments([AP_FEATURE_FLAG], {
        brand: 'misfits-market',
    });
    const inAssortmentPreviewSplitTreatment =
        treatments[AP_FEATURE_FLAG]?.treatment === AP_MODULES_TREATMENT ||
        treatments[AP_FEATURE_FLAG]?.treatment === AP_MODULES_AND_PAGE_TREATMENT;
    const { isReady: splitIsReady, isTimedout: splitTimedOut } = useContext(SplitContext);

    const splitLoadedCorrectly = splitIsReady && !splitTimedOut;

    useEffect(() => {
        const onSneakPeekPage = window.location.pathname === '/grocery-and-produce-delivery-sneak-peek';
        const organicCustomer = !inAssortmentPreviewSplitTreatment && onSneakPeekPage;

        if (inApLocalStorage) setInAssortmentPreview(true);

        if (inApPhaseTwoLocalStorage) setInAssortmentPreviewPhaseTwo(true);

        if (apLocalStorage === 'off' && onSneakPeekPage) {
            localStorage.setItem(AP_LOCALSTORAGE_KEY, AP_PAGE_ORGANIC);
        }

        if (!apLocalStorage) {
            const getVariant = () => {
                if (!onSneakPeekPage) return treatments[AP_FEATURE_FLAG]?.treatment;
                if (organicCustomer) return AP_PAGE_ORGANIC;
                return AP_MODULES_AND_PAGE_TREATMENT;
            };

            localStorage.setItem(AP_LOCALSTORAGE_KEY, getVariant());

            setInAssortmentPreview(treatments[AP_FEATURE_FLAG]?.treatment !== 'off');

            setInAssortmentPreviewPhaseTwo(
                treatments[AP_FEATURE_FLAG]?.treatment === AP_MODULES_AND_PAGE_TREATMENT || onSneakPeekPage
            );
        }
    }, [splitLoadedCorrectly, treatments]);

    return { inAssortmentPreview, inAssortmentPreviewPhaseTwo, apLocalStorage };
}
